<template>
  <div v-loading="listContentLoading">
    <el-button
      style="padding: 0; margin: 20px;"
      type="text"
      icon="el-icon-back"
      @click="$router.go(-1)"
    >
      返回
    </el-button>
    <el-input
      v-if="query.channel_item_id == 0"
      class="search-el"
      size="mini"
      v-model="query.name"
      clearable
      placeholder="请输入推广位名称"
    ></el-input>
    <el-date-picker
      size="mini"
      v-model="query.begin_at"
      format="yyyy-MM-dd"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择开始时间"
    >
    </el-date-picker
    >~
    <el-date-picker
      size="mini"
      v-model="query.end_at"
      format="yyyy-MM-dd"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择结束时间"
    >
    </el-date-picker>

    <el-button type="primary" size="mini" @click="getItemData()">
      查询</el-button
    >

    <el-button
      size="mini"
      @click="
        query.type = 1;
        query.begin_at = '';
        query.end_at = '';
        getItemData();
      "
    >
      近30天</el-button
    >
    <el-button
      size="mini"
      @click="
        query.type = 2;
        query.begin_at = '';
        query.end_at = '';
        getItemData();
      "
    >
      近15天</el-button
    >
    <el-button
      size="mini"
      @click="
        query.type = 3;
        query.begin_at = '';
        query.end_at = '';
        getItemData();
      "
    >
      近7天</el-button
    >

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
          prop="channel_item_name"
          label="推广位名称"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="channel_name"
          label="所属渠道"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="uv"
          label="uv"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="pv"
          label="pv"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="paid_order_num"
          label="付款订单数"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="paid_amount"
          label="付款金额"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="toOrderList(row.code)">
              订单明细
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getItemData"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getItemData } from "@/api/cChannel";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        channel_id: 0,
        channel_item_id: 0,
        name: "",
        type: 1,
        begin_at: "",
        end_at: "",
      },

      listContentLoading: false,
    };
  },
  created: function () {
    if (this.$route.query.channel_id != undefined) {
      this.query.channel_id = Number(this.$route.query.channel_id);
    }
    if (this.$route.query.channel_item_id != undefined) {
      this.query.channel_item_id = Number(this.$route.query.channel_item_id);
    }
    this.getItemData();
  },
  methods: {
    toOrderList(code) {
      this.$router.push({
            path: "/channel/orderList",
            query: {
                code: code,
            },
        });
    },
    getItemData() {
      this.loading = true;
      getItemData(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
  },
  mounted() {},
};
</script>
